import { render, staticRenderFns } from "./ProgressBarChart.vue?vue&type=template&id=4a5c2e27"
import script from "./ProgressBarChart.vue?vue&type=script&lang=js"
export * from "./ProgressBarChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports